import { BrowserRouter, Route, Routes } from "react-router-dom";
import { routes } from "./routes";
import SenoritaHome from "../../page/senorita_home/SenoritaHome";
import { Suspense, useState } from "react";

export const Router = () => {
  const [subDomain] = useState(
    window.location.href.includes("localhost:")
      ? "demo"
      : window.location.href
          .replaceAll("https://", "")
          .replaceAll("http://", "")
          .split(".")[0]
  );
  function navigationRoute() {
    return (
      <BrowserRouter>
        <Suspense fallback={<div></div>}>
          <Routes>
            <Route path={routes.initial} element={<SenoritaHome />}></Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    );
  }

  return navigationRoute();
};
